import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { ClientsData, LogoItem, CLIENTES_DATA } from './clientes.data';

interface Review {
  company: string;
  t1: string;
  t2: string;
  t3: string;
}

type MainKey = 'ent' | 'exp';
const CLI = 'assets/img/clientes/';

@Component({
  selector: 'app-clientes',
  templateUrl: './clientes.component.html',
  styleUrls: ['./clientes.component.scss'],
})
export class ClientesComponent implements OnInit, OnDestroy {
  data: ClientsData = CLIENTES_DATA;

  readonly mains: { key: MainKey; labelKey: string }[] = [
    { key: 'ent', labelKey: 'clientes.mainEnt' },
    { key: 'exp', labelKey: 'clientes.mainExp' },
  ];
  currentMain: MainKey = 'ent';
  currentCountry = '';
  countryLabels: Record<string, string> = {};

  // Testimonios (texto en i18n; logos por índice)
  reviews: Review[] = [];
  readonly reviewLogos = [CLI + 'asovav.webp', CLI + 'grapa.webp', CLI + 'citrogold.webp'];
  revIdx = 0;
  leaving = false;
  private revBusy = false;
  private revTimer?: ReturnType<typeof setInterval>;

  private readonly subs = new Subscription();

  constructor(private readonly translate: TranslateService) {}

  ngOnInit(): void {
    this.subs.add(this.translate.stream('clientes.reviews').subscribe((r: Review[]) => (this.reviews = r || [])));
    this.subs.add(
      this.translate.stream('clientes.country').subscribe((m: Record<string, string>) => {
        this.countryLabels = m || {};
        if (!this.currentCountry) this.selectMain(this.currentMain);
      })
    );
    this.revTimer = setInterval(() => this.changeReview(1), 12000);
  }

  // ---- Logos por país ----
  countriesFor(main: MainKey): string[] {
    const obj = this.data[main] || {};
    const lang = this.translate.currentLang || 'es';
    return Object.keys(obj).sort((a, b) =>
      (this.countryLabels[a] || a).localeCompare(this.countryLabels[b] || b, lang)
    );
  }
  get countries(): string[] {
    return this.countriesFor(this.currentMain);
  }
  get logos(): LogoItem[] {
    return this.data[this.currentMain]?.[this.currentCountry] || [];
  }

  selectMain(key: MainKey): void {
    this.currentMain = key;
    const c = this.countriesFor(key);
    this.currentCountry = c[0] || '';
  }
  selectCountry(c: string): void {
    this.currentCountry = c;
  }

  // ---- Testimonios ----
  get currentReview(): Review | undefined {
    return this.reviews[this.revIdx];
  }
  changeReview(dir: number): void {
    if (this.revBusy || !this.reviews.length) return;
    this.revBusy = true;
    this.leaving = true;
    setTimeout(() => {
      this.revIdx = (this.revIdx + dir + this.reviews.length) % this.reviews.length;
      this.leaving = false;
      this.revBusy = false;
    }, 400);
  }
  prevReview(): void {
    this.changeReview(-1);
  }
  nextReview(): void {
    this.changeReview(1);
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
    if (this.revTimer) clearInterval(this.revTimer);
  }
}
